"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WELCOME_MESSAGE = exports.COPY_LINK_AND_WELCOME_MESSAGE = void 0;
const COPY_LINK_AND_WELCOME_MESSAGE = exports.COPY_LINK_AND_WELCOME_MESSAGE = 'copy-link-and-welcome-message';
const WELCOME_MESSAGE = exports.WELCOME_MESSAGE = 'welcome-message';
